import { translation } from 'easit--localization';
import { IMobileCodeAdvert } from 'eTip--common';
import { Img } from 'common--design-library';
import * as React from 'react';

import "../../../assets/img/tipos-appstore.png";
import "../../../assets/img/tipos-google_play.png";
import classNames from 'classnames';

interface IMobileAppLinkAdvert {
    mobileCodeAdvert: IMobileCodeAdvert;
}

export const MobileAppLinkAdvert: React.FC<IMobileAppLinkAdvert> = (props: IMobileAppLinkAdvert) => {
    const { mobileCodeAdvert } = props;

    return <div className={classNames("mobileLink", __IsMTSTipos__ ? "mb-2" : null)} >
        <div className="text-uppercase mobileLink__header">{translation().mobileAppLinkAdvert_Header}</div>
        <div className="p-2 mobileLink__container">

            <a href={mobileCodeAdvert.appleLinkUrl}>
                <Img src="tipos-appstore.png" alt="" width="200px" />
            </a>

            <a href={mobileCodeAdvert.androidLinkUrl}>
                <Img src="tipos-google_play.png" alt="" width="200px" />
            </a>

        </div>
    </div >
}

